import {Controller} from "@hotwired/stimulus"

class TabsController extends Controller {
  static targets = ["tab", "content"]

  openTab(event) {
    const index = event.params.index
    for (const toggle of this.tabTargets) {
      toggle.classList.remove("active")
    }
    this.tabTargets[index].classList.add("active")
    for (const content of this.contentTargets) {
      content.classList.remove("active")
    }
    this.contentTargets[index].classList.add("active")
    this.dispatch("change", {detail: {index}})
  }
}

export default TabsController
